export default __webpack_public_path__ + "c2e59f2bb3d0591e8516c45b9862c920.png";